import { Fragment, React } from 'react';
import { isSmallViewport } from '../../Hooks/useMedia';

const WaitingTimes = (props) => {
  const isSmall = isSmallViewport();

  const ListView = () => (
    <section className="waiting-times__list-section">
      <h3>{props.Translations.treatment}</h3>
      <dl>
        {props.Treatments.map((item, index) => (
          <Fragment key={index}>
            <dt className="waiting-times__list-section__heading">
              {item.Name}
            </dt>
            <dd className="waiting-times__list-section__item">
              {props.Translations.calculatedtime + ' ' + item.Forecast}
            </dd>
          </Fragment>
        ))}
      </dl>
    </section>
  );

  const TableView = () => (
    <table className="waiting-times__table">
      <thead>
        <tr>
          <th>{props.Translations.treatment}</th>
          <th>{props.Translations.calculatedtimefirstvisit}</th>
        </tr>
      </thead>
      <tbody>
        {props.Treatments.map((item, index) => (
          <tr key={index}>
            <td> {item.Name} </td>
            <td> {item.Forecast} </td>
          </tr>
        ))}
      </tbody>
    </table>
  );

  return (
    <div className="waiting-times">
      {props.WaitingTimesDescription && (
        <p className="waiting-times__description">
          {props.WaitingTimesDescription}
        </p>
      )}
      {props?.Treatments?.length > 0 && isSmall ? <ListView /> : <TableView />}
    </div>
  );
};

export default WaitingTimes;
